import type { FleetCommandView } from '@immo/api-contract';

/**
 * Where an unsettled command is (OPS-57): issued and waiting for its host, sent
 * (handed out), received (the host has it in hand), running (its verb began).
 * A settled command is past all four — its outcome is the news.
 *
 * Read off the latest timestamp present, so a host that skipped a step (or a
 * backend that predates them) still lands on the furthest one it reported.
 */
export type FleetCommandStep = 'waiting' | 'sent' | 'received' | 'running';

export function commandStep(command: FleetCommandView): FleetCommandStep {
  if (command.startedAt != null) return 'running';

  if (command.receivedAt != null) return 'received';

  if (command.sentAt != null) return 'sent';

  return 'waiting';
}
